import React from 'react';
import { SelectHTMLAttributes, OptionHTMLAttributes } from 'react';
import './Select.scss';

interface OptionProps {
    text?: string;
    option?: OptionHTMLAttributes<HTMLOptionElement>
}

export interface UHCSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
    label?: string;
    options: OptionProps[];
}

const UHCSelect: React.FC<UHCSelectProps> = (props: UHCSelectProps) => {

    return (
        <div data-testid='UHCSelectComponent' className="zero-form-field-row">
            <div data-testid='UHCFieldComponent' className={`zero-form-field ${!props.label ? 'without-label' : ''}`} >
                <select data-testid='SelectTest' {...props}>
                    {props.options.map((values, index) => {
                        return <option key={index} data-testid='OptionTest' {...values.option}>{values.text || ''}</option>
                    })}
                </select>
                <label>{props.label}</label>
            </div>
        </div>
    )
}

export default UHCSelect;